export default __webpack_public_path__ + "static/media/bellesartz.9b044836.jpg";